import { useEffect, useState } from "react";

const BooleanInput = ({ postToDB, putToDB, initialFieldData, fieldDataExists, readOnly, hasOdooMapping, odooData }) => {
	const [currentSelection, setCurrentSelection] = useState(3);

	useEffect(() => {
		let newValue = "";
		if (fieldDataExists) {
			newValue = initialFieldData.value;
		}
		/* change logic, now odoo is not the primary source when krummy value is no,
		 because odoo field that some yes/no type field mapped to is boolean field , odoo endpoint (/api/pms/mappings) evaluate false to ""
		 and we don't have access right to edit the odoo endpoitn any more.
		*/
		if (hasOdooMapping && newValue !== "no") {
			if (odooData && odooData.odoo_value !== "failedtogetdataforpmscode400") {
				newValue = odooData.odoo_value;
			} else if (odooData && odooData.odoo_value === "failedtogetdataforpmscode400") {
				if (fieldDataExists) {
					newValue = initialFieldData.value;
				}
			} else {
				newValue = "";
			}
		}
		if (newValue === 1 || newValue === "1" || (typeof newValue === "string" && newValue.toLowerCase() === "yes") || newValue === true || (typeof newValue === "string" && newValue.toLowerCase() === "true")) {
			newValue = "yes";
		}
		if (newValue === 0 || newValue === "0" || (typeof newValue === "string" && newValue.toLowerCase() === "no") || newValue === false || (typeof newValue === "string" && newValue.toLowerCase() === "false")) {
			newValue = "no";
		}
		setCurrentSelection(newValue);
	}, [initialFieldData, fieldDataExists, hasOdooMapping, odooData]);

	const processClick = (value) => {
		if (readOnly) {
			return;
		}
		if (value === currentSelection) {
			setCurrentSelection("");

			if (fieldDataExists === false) {
				postToDB("");
			} else {
				putToDB("");
			}
		} else {
			setCurrentSelection(value);
			if (fieldDataExists === false) {
				postToDB(value);
			} else {
				putToDB(value);
			}
		}
	};

	return (
		<div className="flex gap-3 text-white">
			<button
				disabled={readOnly}
				className={`rounded-lg px-4 py-1 ${currentSelection === "yes" ? "bg-blue-700" : "bg-gray-200"}`}
				onClick={() => processClick("yes")}>
				Yes
			</button>
			<button
				disabled={readOnly}
				className={`rounded-lg px-4 py-1 ${currentSelection === "no" ? "bg-blue-700" : "bg-gray-200"}`}
				onClick={() => processClick("no")}>
				No
			</button>
		</div>
	);
};

export default BooleanInput;
